import { Timestamp } from '@firebase/firestore-types';

export namespace Profiles {
  export enum IndexField {
    CREATED_AT = 'createdAt',
    GROUPS = 'groups',
    TYPE = 'type'
  }

  export enum Type {
    INFOBOX = 'infobox',
    SUATV = 'suatv',
    USER = 'user'
  }

  export enum Role {
    ROOT = 'root',
    ADMIN = 'admin',
    EDITOR = 'editor',
    READER = 'reader'
  }

  export interface Roles {
    reader: boolean;
    editor?: boolean;
    admin?: boolean;
    root?: boolean;
  }
}

export class Profile {
  id?: string;
  createdAt: Timestamp;
  modifiedAt: Timestamp;
  groups: string[];
  organizationId: string;
  type: Profiles.Type;
  roles: Profiles.Roles;
  constructor(type: Profiles.Type) {
    this.type = type;
    this.roles = { reader: true };
  }
}

export class UserProfile extends Profile {
  firstName: string;
  lastName: string;
  displayName: string;
  pictureUrl: string;
  title: string;
  email: string;
  birthdate: string;
  phoneNumber: string;
  constructor() {
    super(Profiles.Type.USER);
  }
}

export class SuatvProfile extends Profile {
  name: string;
  constructor() {
    super(Profiles.Type.SUATV);
  }
}

export class InfoboxProfile extends Profile {
  name: string;
  constructor() {
    super(Profiles.Type.INFOBOX);
  }
}
